import { render } from "./HomeView_PC.vue?vue&type=template&id=891e5784"
import script from "./HomeView_PC.vue?vue&type=script&lang=js"
export * from "./HomeView_PC.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__